import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import ThemeButtonFloating from 'assets/components/button/themes/Theme.Button.Floating';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageList from 'assets/components/page/themes/Theme.Page.List';
import Pagination from 'assets/components/pagination/Pagination';
import ThemePaginationRounded from 'assets/components/pagination/themes/Theme.Pagination.Rounded';
import { getLocales } from 'assets/locales/Locale';
import { DataProvider } from 'assets/providers/data/DataProvider';
import ErrorPage from 'assets/templates/errorPage/ErrorPage';
import { HttpStatus, productManagementHomeRoute } from 'config/Api.Config';
import { isMobile } from 'react-device-detect';
import useVehicleMake, { VehicleMakeAction } from './VehicleMake.Hooks';
import VehicleMakeDelete from './sections/VehicleMake.Delete';
import VehicleMakeEdit from './sections/VehicleMake.Edit';
import VehicleMakeFilters from './sections/VehicleMake.Filters';
import VehicleMakeImportExcel from './sections/VehicleMake.ImportExcel';
import VehicleMakeList from './sections/VehicleMake.List';
import Box from 'assets/components/box/Box';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';

enum Actions {
  EDIT = 'edit',
  DELETE = 'delete',
  IMPORT_EXCEL = 'importExcel',
}
export type Verify = Utils.VerifyExtends<Module.ProductManagement.VehicleMake.Actions, Utils.ValueOf<typeof Actions>>;
export const vehicleMakeIndexRoute = productManagementHomeRoute + '/vehicleMake/:action?/:id?';
export default function VehicleMakeIndex() {
  const { lang } = getLocales();
  const vehicleMakeHook = useVehicleMake();

  if (!vehicleMakeHook.canView) return <ErrorPage status={HttpStatus.unauthorized} />;
  return (
    <>
      <DataProvider
        data={vehicleMakeHook}
        render={({ listApi, views, pageRouter, permissions }) => (
          <Page
            class={ThemePageList}
            isLoading={listApi.isExecuting}
            header={
              <>
                <h2 style={{ marginRight: 'auto' }} children={lang.vehicleMake} />
                <Box class={ThemeWrapperStack}>
                  {isMobile && <VehicleMakeFilters />}
                  <Button
                    class={isMobile ? ThemeButtonFloating : ThemeButtonCircle}
                    active
                    media={<Icon class="fas-plus" />}
                    render={!isMobile && lang.import}
                    onClick={pageRouter.updateParams}
                    disabled={!permissions.IMPORT_VEHICLEMAKE_FROM_EXCEL}
                    data={{ action: VehicleMakeAction.IMPORT_EXCEL }}
                  />
                  <Button
                    class={isMobile ? ThemeButtonFloating : ThemeButtonCircle}
                    active
                    media={<Icon class="fas-plus" />}
                    render={!isMobile && lang.addNew}
                    onClick={pageRouter.updateParams}
                    disabled={!permissions.CREATE_VEHICLEMAKE}
                    data={{ action: VehicleMakeAction.EDIT }}
                  />
                </Box>
              </>
            }
            subHeader={!isMobile && <VehicleMakeFilters />}
            render={
              <>
                {views.edit && <VehicleMakeEdit />}
                {views.delete && <VehicleMakeDelete />}
                {views.importExcel && <VehicleMakeImportExcel />}
                <VehicleMakeList />
              </>
            }
            footer={
              <Pagination
                class={ThemePaginationRounded}
                count={listApi.payload?.count}
                offset={listApi.body?.offset}
                limit={listApi.body?.limit}
                onLimitChange={(limit) => listApi.execute((body) => ({ ...body, limit, offset: 0 }))}
                onOffsetChange={(offset) => listApi.execute((body) => ({ ...body, offset }))}
              />
            }
          />
        )}
      />
    </>
  );
}
